import React from 'react';
import { CloudUpload, Settings } from 'lucide-react';
import Container from '@/components/ui/Container';
import DashboardHeader from '@/components/dashboard/DashboardHeader';
import SidebarLayout from '@/components/layout/SidebarLayout';
import MobilePageWrapper from '@/components/ui/MobilePageWrapper';
import { UniversalLibrarySidebar, UniversalLibraryHeader, UniversalLibraryEmptyState } from '@/components/universal-storage';
import UniversalLibraryGridDnD from '@/components/universal-storage/UniversalLibraryGridDnD';
import DashboardCard from '@/components/ui/DashboardCard';
import { useGlobalModals } from '@/contexts/GlobalModalsContext';

const UniversalStoragePage = () => {
  const { openCategoryModal } = useGlobalModals();

  const handleManageStorage = () => {
    openCategoryModal();
  };

  // Remove items placeholder. Data comes from useUniversalLibraryData.
  return (
    <MobilePageWrapper>
      <Container>
        <DashboardHeader
          title="Content Storage"
          description="All your generated content, ideas, and assets in one place."
          icon={<CloudUpload size={24} />}
        />
        <div className="space-y-3 md:space-y-6">
          <SidebarLayout sidebar={<UniversalLibrarySidebar />}>
            <DashboardCard noPadding>
              <div className="p-3 md:p-6">
                <UniversalLibraryHeader />
                {/* Use the new grid */}
                <UniversalLibraryGridDnD />
              </div>
            </DashboardCard>
          </SidebarLayout>
        </div>
      </Container>
    </MobilePageWrapper>
  );
};

export default UniversalStoragePage;
